import React, {useEffect, useState} from "react";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import "./AdminModern.scss";
import {Link, useNavigate} from "react-router-dom";
import GoingBack from "../../components/GoingBack/GoingBack";
import Cookies from "js-cookie";
import IsAdmin from "../../components/Admin/IsAdmin";

function AdminCodePromo() {
    const [codePromo, setCodePromo] = useState("");
    const [remise, setRemise] = useState();
    const [remiseEnVirgule, setRemiseEnVirgule] = useState();
    const [dateExpiration, setDateExpiration] = useState("");
    const [codePromos, setCodePromos] = useState([]);
    const [idCodePromoStripe, setIdCodePromoStripe] = useState("");
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(null);


    const addStripeCode = async () => {
        try {
            const stripeObject = {
                codePromo: codePromo,
                reduction: remise,
                dateValidite: dateExpiration,
            }
            const addCodePromo = async () => {
                const response = await fetch(`${process.env.REACT_APP_API_URL}codePromo/stripe`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get("auth_token")}`,
                    },
                    body: JSON.stringify(stripeObject),
                });
                const newCodePromo = await response.json();
                setIdCodePromoStripe(newCodePromo);
            }
            addCodePromo();
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (isAdmin === null) {
            return;
        }
        !isAdmin && navigate("/");
    }, [isAdmin]);

    useEffect(() => {
        if (idCodePromoStripe === "") {
            return;
        }
        try {
            const codePromoObject = {
                codePromo: codePromo,
                reduction: remiseEnVirgule,
                reductionValeurEntier: remise,
                dateValidite: dateExpiration,
                idCodePromoStripe: idCodePromoStripe,
            }
            const addCodePromo = async () => {
                const response = await fetch(`${process.env.REACT_APP_API_URL}codePromo/add`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get("auth_token")}`,
                    },
                    body: JSON.stringify(codePromoObject),
                });
                const newCodePromo = await response.json();
                setCodePromos(newCodePromo)
                Swal.fire({
                    title: "Code promo ajouté",
                    icon: "success",
                })
            }
            addCodePromo();
        } catch (error) {
            console.log(error)
        }
    }, [idCodePromoStripe]);


    useEffect(() => {
        try {
            const fetchCodePromo = async () => {
                const response = await fetch(`${process.env.REACT_APP_API_URL}codePromo`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get("auth_token")}`,
                    },
                });
                const codePromos = await response.json();
                setCodePromos(Object.values(codePromos));
            }
            fetchCodePromo();
        } catch (error) {
            console.log(error)
        }
    }, []);

    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
        const day = String(date.getDate()).padStart(2, '0');

        return `${day}-${month}-${year}`;
    }

    const removePromoCode = async (id) => {
        Swal.fire({
            title: "Êtes-vous sûr de vouloir supprimer ce code promo ?",
            showDenyButton: true,
            confirmButtonText: `Oui`,
            denyButtonText: `Non`,
        }).then((result) => {
            if (result.isConfirmed) {
                const removeCodePromoAfterConfirmation = async () => {
                    try {
                        const response = await fetch(`${process.env.REACT_APP_API_URL}codePromo/remove/${id}`, {
                            method: "DELETE",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${Cookies.get("auth_token")}`,
                            },
                        });
                        const newCodePromos = await response.json();
                        setCodePromos(newCodePromos);
                        Swal.fire({
                            title: "Code promo supprimé",
                            icon: "success",
                        })
                    } catch (error) {
                        console.log(error);
                    }
                }
                removeCodePromoAfterConfirmation();
            }
        });
    }

    return (
        <div className="admin-modern-container">
            <IsAdmin setAdmin={setIsAdmin}/>
            <GoingBack/>
            
            <div className="admin-header">
                <h2>Gestion des Codes Promo</h2>
                <p>Créer et gérer les codes promotionnels</p>
            </div>

            <div className="admin-grid-2" style={{ alignItems: "start" }}>
                {/* Formulaire d'ajout */}
                <div className="admin-card">
                    <h3 style={{ marginBottom: "1.5rem" }}>Ajouter un nouveau code promo</h3>
                    <p style={{ color: "var(--admin-text-muted)", fontSize: "0.9rem", marginBottom: "1.5rem" }}>
                        Exemple : CODEPROMO1234, Remise % : 20, Remise virgule : 0.2, Exp : 2024-04-01
                    </p>
                    
                    <div className="admin-form-group">
                        <label>Code promo</label>
                        <input className="admin-input" type="text"
                               onChange={(e) => setCodePromo(e.target.value)} />
                    </div>
                    
                    <div className="admin-grid-2">
                        <div className="admin-form-group">
                            <label>Remise en %</label>
                            <input className="admin-input" type="number" placeholder="ex: 20"
                                   onChange={(e) => setRemise(e.target.value)}/>
                        </div>
                        <div className="admin-form-group">
                            <label>Remise virgule</label>
                            <input className="admin-input" type="number" step="0.01" placeholder="ex: 0.2"
                                   onChange={(e) => setRemiseEnVirgule(e.target.value)}/>
                        </div>
                    </div>
                    
                    <div className="admin-form-group">
                        <label>Date d'expiration</label>
                        <input className="admin-input" type="date"
                               onChange={(e) => setDateExpiration(e.target.value)}/>
                    </div>
                    
                    <button className="admin-btn admin-btn-primary" onClick={() => addStripeCode()}>
                        <svg style={{width:"1.2rem", height:"1.2rem"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>
                        Ajouter le code promo
                    </button>
                </div>

                {/* Liste des codes */}
                <div className="admin-card">
                    <h3 style={{ marginBottom: "1.5rem" }}>Codes promos actifs</h3>
                    
                    <div className="admin-data-list">
                        <div className="admin-data-header">
                            <div>Code</div>
                            <div>Réduction</div>
                            <div>Expiration</div>
                            <div>Statut</div>
                            <div style={{ flex: "0 0 50px", textAlign: "right" }}>Action</div>
                        </div>
                        
                        {codePromos.map((codePromo, index) => {
                            const isExpired = new Date(codePromo.dateValidite) < new Date();
                            return (
                                <div key={index} className="admin-data-card">
                                    <div className="admin-data-row">
                                        <div className="admin-data-item">
                                            <span className="admin-data-label">Code</span>
                                            <span className="admin-data-value" style={{ fontWeight: "bold" }}>{codePromo.codePromo}</span>
                                        </div>
                                        <div className="admin-data-item">
                                            <span className="admin-data-label">Réduction</span>
                                            <span className="admin-data-value">{codePromo.reductionValeurEntier} %</span>
                                        </div>
                                        <div className="admin-data-item">
                                            <span className="admin-data-label">Expiration</span>
                                            <span className="admin-data-value">{formatDate(codePromo.dateValidite)}</span>
                                        </div>
                                        <div className="admin-data-item">
                                            <span className="admin-data-label">Statut</span>
                                            {isExpired ? 
                                                <span className="admin-badge admin-badge-danger">Expiré</span> : 
                                                <span className="admin-badge admin-badge-success">Valide</span>
                                            }
                                        </div>
                                    </div>
                                    <div className="admin-data-actions">
                                        <button className="admin-btn admin-btn-outline" style={{ padding: "0.5rem", color: "var(--admin-danger)", borderColor: "var(--admin-danger-bg)" }} onClick={() => removePromoCode(codePromo._id)}>
                                            <FontAwesomeIcon icon={faXmark} />
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                        {codePromos.length === 0 && (
                            <div style={{ textAlign: "center", padding: "2rem", color: "var(--admin-text-muted)" }}>
                                Aucun code promo n'a été créé pour le moment.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminCodePromo;